export default __webpack_public_path__ + "static/media/eden.27cbf587.svg";